/* Magic in my Marks - buy block + Ajax cart (Dawn compatible) */
(function () {
  var form = document.getElementById('mim-product-form');
  if (!form) return;

  var d = form.dataset;
  var moneyFormat = d.moneyFormat || '${{amount}}';

  // ---- Shopify-style money formatter ----
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = parseInt(cents, 10) || 0;
    var value = '';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    function defaultTo(n, d) { return (typeof n === 'undefined' || n === null) ? d : n; }
    function num(number, precision, thousands, decimal) {
      precision = defaultTo(precision, 2);
      thousands = defaultTo(thousands, ',');
      decimal = defaultTo(decimal, '.');
      var n = (cents / 100.0).toFixed(precision);
      var parts = n.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? (decimal + parts[1]) : '';
      return dollars + centsPart;
    }
    var match = format.match(placeholder);
    var token = match ? match[1] : 'amount';
    switch (token) {
      case 'amount': value = num(2, ',', '.'); break;
      case 'amount_no_decimals': value = num(0, ',', '.'); break;
      case 'amount_with_comma_separator': value = num(2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = num(0, '.', ','); break;
      case 'amount_with_space_separator': value = num(2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = num(0, ' ', ''); break;
      case 'amount_with_apostrophe_separator': value = num(2, "'", '.'); break;
      default: value = num(2, ',', '.');
    }
    return format.replace(placeholder, value);
  }

  // ---- elements ----
  var idInput = document.getElementById('mim-variant-id');
  var qtyInput = document.getElementById('mim-qty');
  var qtyMinus = document.getElementById('mim-qty-minus');
  var qtyPlus = document.getElementById('mim-qty-plus');
  var addBtn = document.getElementById('mim-add');
  var addPrice = document.getElementById('mim-add-price');
  var buyPrice = document.getElementById('mim-buy-price');
  var signedCheck = document.getElementById('mim-signed');
  var dedication = document.getElementById('mim-dedication');
  var dedicationInput = document.getElementById('mim-dedication-name');

  function isSigned() { return signedCheck && signedCheck.checked; }
  function unitCents() {
    return parseInt(isSigned() ? d.signedCents : d.standardCents, 10) || 0;
  }
  function currentVariantId() {
    return isSigned() ? d.signedId : d.standardId;
  }
  function getQty() {
    var q = parseInt(qtyInput.value, 10);
    if (isNaN(q) || q < 1) q = 1;
    if (q > 20) q = 20;
    return q;
  }

  function refresh() {
    var q = getQty();
    qtyInput.value = q;
    idInput.value = currentVariantId();
    var unit = unitCents();
    buyPrice.innerHTML = formatMoney(unit, moneyFormat);
    addPrice.textContent = formatMoney(unit * q, moneyFormat);
    if (signedCheck && dedication) {
      var on = isSigned();
      dedication.classList.toggle('show', on);
      if (dedicationInput) dedicationInput.disabled = !on;
    }
  }

  if (qtyMinus) qtyMinus.addEventListener('click', function () { qtyInput.value = getQty() - 1; refresh(); });
  if (qtyPlus) qtyPlus.addEventListener('click', function () { qtyInput.value = getQty() + 1; refresh(); });
  qtyInput.addEventListener('input', refresh);
  if (signedCheck) signedCheck.addEventListener('change', refresh);

  // ---- toast ----
  var toastEl;
  var toastTimer;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'mim-toast';
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('show'); }, 1700);
  }

  // ---- Dawn cart drawer integration ----
  function dawnDrawer() {
    var el = document.querySelector('cart-drawer');
    if (el && typeof el.renderContents === 'function') return el;
    return null;
  }

  function addToCart(variantId, qty, extraProps) {
    var drawer = dawnDrawer();
    var body = {
      items: [{ id: variantId, quantity: qty }]
    };
    if (extraProps) body.items[0].properties = extraProps;

    var fetchCfg = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: null
    };

    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      var ids = drawer.getSectionsToRender().map(function (s) { return s.id; });
      body.sections = ids;
      body.sections_url = window.location.pathname;
    }
    fetchCfg.body = JSON.stringify(body);

    addBtn && addBtn.setAttribute('aria-busy', 'true');

    fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', fetchCfg)
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) { // error object
          toast(res.description || 'Could not add to basket');
          return;
        }
        toast('Added to basket');
        if (drawer && res.sections) {
          drawer.classList.remove('is-empty');
          drawer.renderContents(res);
          if (typeof drawer.open === 'function') drawer.open();
        } else {
          window.location = d.cartUrl || '/cart';
        }
      })
      .catch(function () { toast('Something went wrong. Please try again.'); })
      .finally(function () { addBtn && addBtn.removeAttribute('aria-busy'); });
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var props = null;
    if (isSigned() && dedicationInput && dedicationInput.value.trim()) {
      props = { 'Dedication name': dedicationInput.value.trim() };
    }
    addToCart(currentVariantId(), getQty(), props);
  });

  // expose a hook for the sticky bar (adds 1 standard copy)
  window.mimAddStandard = function () {
    addToCart(d.standardId, 1, null);
  };

  refresh();
})();
